import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageToggleProps {
  isScrolled?: boolean;
}

export default function LanguageToggle({ isScrolled = false }: LanguageToggleProps) {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState(i18n.language);

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'tr' : 'en';
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

  return (
    <button
      onClick={toggleLanguage}
      className={`flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium transition-all whitespace-nowrap cursor-pointer ${
        isScrolled
          ? 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          : 'bg-white/10 text-white hover:bg-white/20'
      }`}
    >
      <span className={currentLang === 'en' ? 'opacity-100' : 'opacity-50'}>EN</span>
      <span className="text-[10px] opacity-50">|</span>
      <span className={currentLang === 'tr' ? 'opacity-100' : 'opacity-50'}>TR</span>
    </button>
  );
}
